import {InvenTypeVo} from '../../../../common/shared/api/gateway/enums/InvenTypeVo.enum';
import {InvenListInfiniteQueryProps, InvenListQueryProps} from '../type';

export function getInvenListQuery({invenType, data}: InvenListQueryProps) {
  switch (invenType) {
    case InvenTypeVo.Recent:
      return data.invenRecentList;
    case InvenTypeVo.Paid:
      return data.invenPaidList;
    case InvenTypeVo.Like:
      return data.invenLikeList;
  }
}

export function getInvenListInfiniteQuery({
  invenType,
  data,
}: InvenListInfiniteQueryProps) {
  return data.pages
    .map(page => getInvenListQuery({invenType, data: page}))
    .reduce((prev, cur) =>
      cur
        ? {
            ...prev,
            ...cur,
            list: [...(prev?.list ?? []), ...(cur?.list ?? [])],
          }
        : prev
    );
}
